module.exports = __webpack_public_path__ + "img/logout.30b4250b.svg";